import React from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Routes from 'routes';
import ReactGA from 'react-ga';
ReactGA.initialize(process.env.GOOGLE_ANALYTICS || 'G-4C88NR5R2Q');
ReactGA.pageview(window.location.pathname + window.location.search);

const App = () => {
  const dispatch = useDispatch();
  return (
    <BrowserRouter basename='/'>
      <Routes />
    </BrowserRouter>
  );
}

export default App;
